// Importa dai moduli corretti di Serenity
import { Decorators, PropertyDialog } from '@serenity-is/corelib';
import { notifySuccess, serviceCall } from '@serenity-is/corelib';
import { resolveUrl, formatDate } from '@serenity-is/corelib';
import { text, format } from '@serenity-is/corelib';

// Importa i tuoi tipi dal nuovo namespace
import { WorkingDaysRequest, CalculationType } from '@/ServerTypes/Modules';
import { WorkingDaysResponse } from './WorkingDaysTypes'; 
import { WorkingDaysForm } from '@/ServerTypes/Modules';

Decorators.registerClass("MRMX.Common.WorkingDays.WorkingDaysDialog");
export class WorkingDaysDialog extends PropertyDialog<WorkingDaysRequest, any> {
    protected getFormKey() { return WorkingDaysForm.formKey; }
    protected form = new WorkingDaysForm(this.idPrefix);

    constructor() {
        super();
        this.dialogTitle = "Calcolo Giorni Lavorativi";

        // Gestione visibilità campi
        this.form.CalculationType.changeSelect2(e => this.updateVisibility());
        this.updateVisibility();
    }

    protected getDialogOptions() {
        let opt = super.getDialogOptions();
        opt.width = 500;
        return opt;
    }

    private updateVisibility() {
        if (!this.form.CalculationType.value) return;

        const value = CalculationType[this.form.CalculationType.value as keyof typeof CalculationType];

        this.form.SingleDate.element.closest('.field').toggle(value === CalculationType.NextWorkingDay);
        this.form.StartDate.element.closest('.field').toggle(
            value === CalculationType.CalculateEndDate ||
            value === CalculationType.CountDays
        );
        this.form.EndDate.element.closest('.field').toggle(value === CalculationType.CountDays);
        this.form.WorkingDays.element.closest('.field').toggle(value === CalculationType.CalculateEndDate);
    }

    protected getDialogButtons() {
        return [{
            text: text('WorkingDays.Buttons.Calculate'),
            click: () => {
                if (!this.validateForm())
                    return;

                const request: WorkingDaysRequest = {
                    CalculationType: CalculationType[this.form.CalculationType.value as keyof typeof CalculationType],
                    SingleDate: this.form.SingleDate.valueAsDate.toDateString(),
                    StartDate: this.form.StartDate.valueAsDate.toDateString(),
                    EndDate: this.form.EndDate.valueAsDate.toDateString(),
                    WorkingDays: this.form.WorkingDays.value,
                    IncludeSaturday: this.form.IncludeSaturday.value
                };

                serviceCall<WorkingDaysResponse>({
                    url: resolveUrl('~/Services/WorkingDays/Calculate'),
                    request: request,
                    onSuccess: response => {
                        let message = '';
                        const value = request.CalculationType;

                        switch (value) {
                            case CalculationType.NextWorkingDay:
                                message = format(text('WorkingDays.NextWorkingDayResult'),
                                    formatDate(response.Date));
                                break;
                            case CalculationType.CalculateEndDate:
                                message = format(text('WorkingDays.CalculateEndDateResult'),
                                    formatDate(response.Date));
                                break;
                            case CalculationType.CountDays:
                                message = format(text('WorkingDays.CountDaysResult'),
                                    response.WorkingDays);
                                break;
                        }
                        notifySuccess(message);
                        this.dialogClose();
                    }
                });
            }
        },
        {
            text: text('WorkingDays.Buttons.Cancel'),
            click: () => this.dialogClose()
        }];
    }
}